import React, { FC } from 'react';
import { CheckCont, FlagImage, FlexibleTileDropCont } from './FlexibleDropdownTile.styles';
import { IDropdownItem } from '../FlexibleDropdown';
import CheckIcon from '@/assets/icons/checkMark.svg?react';

interface IFlexibleDropdownTile {
  item: IDropdownItem;
  setItem: (item: IDropdownItem) => void;
  active?: boolean;
}

const FlexibleDropdownTile: FC<IFlexibleDropdownTile> = ({ item, setItem, active }) => {
  const { icon, name } = item;
  return (
    <FlexibleTileDropCont
      id="FlexibleTileDropCont"
      data-testid="FlexibleDropTileEl"
      active={active}
      onClick={() => setItem(item)}
    >
      {icon && <FlagImage id="FlagImage" src={icon} />}
      {name}
      {active && (
        <CheckCont data-testid="FlexibleDropActiveMark">
          <CheckIcon />
        </CheckCont>
      )}
    </FlexibleTileDropCont>
  );
};

export default FlexibleDropdownTile;
